import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, DOCUMENT, effect, Inject, Signal } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { StoreService } from '@store/store.service';
import { LoadingSpinnerComponent } from '@shared/ui/loading-spinner/loading-spinner.component';
import { LoadingState } from '@app/utils/models/store/loading-state.model';
import { TranslocoDirective } from '@jsverse/transloco';
import { tap } from 'rxjs/operators';
import { filter } from 'rxjs';

@Component({
  selector: 'ess-loading-screen',
  imports: [CommonModule, LoadingSpinnerComponent, TranslocoDirective],
  templateUrl: './loading-screen.component.html',
  styleUrls: ['./loading-screen.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingScreenComponent {
  loadingState$$: Signal<LoadingState>;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private store: StoreService,
  ) {
    this.loadingState$$ = toSignal(this.store.loadingState$, { requireSync: true });

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        tap(() => this.store.setIsLoading(false)),
        takeUntilDestroyed(),
      )
      .subscribe();

    effect(() => {
      this.blockOverflow(this.loadingState$$().isLoading);
    });
  }

  private blockOverflow(isLoading: boolean): void {
    if (isLoading) {
      this.document.body.classList.add('loading');
    } else {
      this.document.body.classList.remove('loading');
    }
  }
}
